<div class="col-md-12 px-3">
  <div class="row g-0">
    <div class="col-8">
      <b>Note:</b>
      <span class="note-head" [ngStyle]="{'padding-left': cookie == 'pl' ? '4rem' : '3.2rem'}">To quickly have access to payments, please verify your bank by linking it to your <span class="notranslate">Denefits</span>
        account.Linking your bank account is the quickest way to verify your information.
      </span>
    </div>
    <div class="col-12 pb-2" style="min-height: 150px;" *ngIf="profile">
      <h3 class="heading-font">Verify Bank Account</h3>
      <span class="px-2">
        <button class="btn px-5 btn-wrap" mat-raised-button (click)="addBankAccount()"
          *ngIf="profile?.auth_bank_status !== 'verified'">
          {{profile.auth_bank_status == 'reauthenticate' ? 'Reauthenticate Bank': 'Add Bank'}}
        </button>
      </span>
      <p class="py-4 ms-2" *ngIf="profile?.auth_bank_status !== 'verified'">
        <span class="notranslate">Denefits</span> <img src="assets/img/png/plaid-logo.png" style="position: relative; display: inline-block;"> to connect
        your account
      </p>
      <div class="col-md-12 px-0" *ngIf="profile?.auth_bank_status === 'verified'">
        <div class="col-md-6 px-0">
          <div
            class="form-input bg_account rounded border-0 d-flex align-items-center justify-content-between col-md-10 col-12"
            style=" min-width: 330px;">
            <span class="d-flex align-items-center">
              <img src="assets/img/svg/bank.svg">
              <span class="px-2">XXXX-XXXX-{{profile && profile.auth_bank && profile.auth_bank[0] && profile.auth_bank[0].last4}}</span>
            </span> <span class="success_color d-none d-md-block"><i class="fa fa-check-circle" aria-hidden="true"></i>
              Verified</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" style="min-height:150px;">
      <form #addCardForm="ngForm">
        <h3 class="heading-font" style="margin-top: 2px !important;">Verify Card</h3>
        <div class="mt-4" *ngIf="profile?.is_auth_card_added == 0">
          <div class="form-group col-12 col-md-6 col-xl-6 px-0 mb-3" *ngIf="profile?.is_auth_card_added !== 1">
            <div class="custom-form flex-grow-1 me-md-3">
              <input class="input_field px-2 pt-3 ps-3" [(ngModel)]="payment_option.cardName" autofocus name="cardName"
                #cardName="ngModel" required trim />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Card Holder Name
                </span>
              </label>
            </div>
          </div>
          <div class="form-group col-12 col-md-6 col-xl-6 px-0 mb-3" *ngIf="profile?.is_auth_card_added !== 1">
            <div class="stripe-card border_8 w-100 py-2 mb-0" style="height: 54px !important;align-content: center;"
            id="payment-element"></div>
          </div>

          <span class="mt-2">
            <button class="px-5 btn-wrap" mat-raised-button *ngIf="profile?.is_auth_card_added !== 1" (click)="sendCardDetails()">
              Add Card
            </button>
          </span>
        </div>

        <div class="mt-4" *ngIf="profile?.is_auth_card_added == 1">
          <div class="col-md-6 px-0">
            <div
              class="form-input bg_account rounded border-0 d-flex align-items-center justify-content-between col-md-10 col-12"
              style=" min-width: 330px;">
              <span class="d-flex align-items-center">
                <img style="width:24px;"
                [src]="getCardBrandImage(profile.auth_card[0])"
                *ngIf="['mastercard', 'discover', 'jcb', 'visa', 'american express', 'unionpay', 'diners club', 'diners', 'amex'].includes(profile.auth_card[0].brand.toLowerCase()); else no_card">
                              <ng-template #no_card>
                                <img style="width:24px;"
                                [src]="'assets/img/svg/card-type/no_card.svg'"
                                >
                            </ng-template>
                <span class="px-2">XXXX XXXX XXXX {{profile && profile.auth_card && profile.auth_card[0] && profile.auth_card[0].last4}}</span>
              </span> <span class="success_color d-none d-md-block"><i class="fa fa-check-circle"
                  aria-hidden="true"></i>
                Verified</span>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="col-12" style="min-height:200px;">
      <h3 class="heading-font">Upload documents for Verification</h3>
      <div class="card mb-4" *ngFor="let docs of verifyDocs;let i = index;">
        <div class="card-body d-flex ">
          <span class="me-2 d-flex" style="margin-top: -2px;">{{i+1}}.</span>
          <div class="w-100 d-flex mt-0 justify-content-between">
            <div class="d-flex flex-1 pe-1 ">
              <h6>{{docs?.name}} <span class="text-danger fw-600" *ngIf="docs.is_expired && docs.is_rejected == 0">(Expired)</span>
                <span class="text-danger fw-600" *ngIf="docs.is_rejected == 0 && docs.show_reupload == 1 && docs.is_expired == 0">(Expiring Soon)</span>
              </h6>
            </div>
            <div class="d-flex">
              <div class="upload-file">
                <label [for]="'input1_'+i"
                  *ngIf="docs?.doc_uploaded !== 1 || docs?.is_rejected ==1 || docs?.is_deleted == 1">
                  <p class="upload-btn mb-0">
                    <input (change)="uploadFile($event,docs)" [name]="docs.type" type="file" [id]="'input1_'+i"
                      class="hidden" style="display: none" accept=" .jpeg, .jpg, .png, .pdf"/>
                    Upload
                  </p>
                </label>
              </div>
              <figure class="d-flex" *ngIf="docs?.doc_uploaded === 1 && docs?.is_rejected == 0">
                <a [href]="docs.doc_url" class="px-2" target="_blank" style="color:#3679DE">
                  <img class="me-2" src="assets/img/png/eye.png" alt="" title="view document">
                </a>
                <label [for]="'input21_'+i" class="px-2" title="ReUpload Documents" style="color:#3679DE" *ngIf="(docs.is_expired == 1 && docs.is_approved == 1) || docs.is_expired == 1 || docs.show_reupload == 1">
                  <img class="me-2 pointer" src="assets/img/svg/upload_2.svg" alt=""  style="width: 25px;">
                  <input (change)="deleteDocumentandUpload($event,docs)" [name]="docs.type" type="file" [id]="'input21_'+i"
                      class="hidden" style="display: none" accept=" .jpeg, .jpg, .png, .pdf"/>
                </label>
                <a href="javascript:void(0)" (click)="deleteDocument(docs.id)" *ngIf="docs?.is_approved == 0 && docs.is_expired == 0"
                  class="px-2 text-danger-custom">
                  <img src="assets/img/png/cut.png" alt="" title="delete document">
                </a>
              </figure>
            </div>
          </div>
        </div>
      </div>

      <div class="py-2 d-flex" *ngIf="verifyDocs && verifyDocs.length !== docsLength">
        <button (click)="addMoreDocument()" class="more-btn" *ngIf="moreDocuments.length == 0">
          + Add More Documents
        </button>
        <span class="d-flex m-3 doc-text" *ngIf="moreDocuments.length == 0">You can add upto 10 documents</span>
      </div>
      <ng-container *ngIf="moreDocuments.length !==0">
        <div class="card mb-4" *ngFor="let docs of moreDocuments;let i = index;">
          <div class="card-body d-flex ">
            <div class="w-100">
              <div class="d-flex w-100">
                <div class="custom-form flex-grow-1 me-md-3 ">
                  <input class="input_field px-3 pt-3" type="text" (change)="namchange($event,i)" required
                    trim  (keydown)="handleInput($event)" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      File Name
                    </span>
                  </label>
                </div>
                <p class="mat-error" *ngIf="docs.error == true">
                  Please enter valid file name.
                </p>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-3">
                <div class="upload-file">
                  <label [for]="'input2_'+i">
                    <p class="upload-btn mb-0" style="cursor: pointer;">
                      <input (change)="getFormvalues($event,i)" [disabled]="docs.file_name == ''"
                        [name]="docs.file_name" type="file" [id]="'input2_'+i" class="hidden" style="display: none" accept=" .jpeg, .jpg, .png, .pdf"/>
                      Upload
                    </p>
                  </label>
                </div>
                <button (click)="moreDocuments = []" class="px-2 text-danger-custom">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="py-0 px-0 mt-3 mb-3">
        <textarea placeholder="Note" class="text-area" [(ngModel)]="notes" style="resize: none;"></textarea>
      </div>
    </div>
    <div class="d-flex align-items-center py-2 mb-3">
      <button class="btn-lg w-auto" [disabled]="profile && profile.auth_doc_uploaded == 0 || documents_uploaded == 0" mat-raised-button (click)="saveNote()"
        style="height: 42px;width: 110px;">
        Save
      </button>
    </div>
  </div>
</div>